
<!-- TODO: Traiter surTitre,titre et sousTitre -->
<div v-if="isLienActif" class="d-flex flex-column" :class="jel_getClassObject(content)">
  <span @click.capture="gaPreventClick">
    <b-link v-bind="jel_getLienBinding(content.lien)">
      <b-img-lazy :src="jel_getFichierSrc(content.image)" :alt="content.altImage" />
    </b-link>
  </span>
</div>
<div v-else class="d-flex flex-column">
  <b-img-lazy
    :src="jel_getFichierSrc(content.image)"
    :alt="content.altImage"
    :class="content.cssImage"
  />
</div>
